import { Alert, AlertTitle, Box, Typography } from '@mui/material';

interface TimeChangeWarningContentProps {
  clearNotifiedOnTimeChangeEnabled: boolean;
}

export const TimeChangeWarningContent = ({ clearNotifiedOnTimeChangeEnabled }: TimeChangeWarningContentProps) => {
  if (!clearNotifiedOnTimeChangeEnabled) return null;

  return (
    <Box sx={{ pt: 2 }}>
      <Alert severity="warning">
        <AlertTitle>Notification Status Will Be Cleared</AlertTitle>
        Changing the job time will clear the notification status of all assigned crew members.
      </Alert>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1.5 }}>
        This action cannot be undone.
      </Typography>
    </Box>
  );
};
